(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('GcSystem', GcSystem);

    GcSystem.$inject = ['$resource'];

    function GcSystem ($resource) {
        var resourceUrl =  'api/gc-systems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
